import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* width: 342px; */

  [data-palmerhq-radio-group] {
    padding: 0;
    margin: 0;
    list-style: none;
    margin-bottom: 24px;
  }

  [data-palmerhq-radio-group]:focus {
    outline: none;
  }

  [data-palmerhq-radio] {
    border: 2px solid transparent;
    border-radius: 5px;
    display: inline-block;
    position: relative;
    padding-left: 32px;
    cursor: default;
    outline: none;
    font-size: 16px;
    line-height: 24px;
  }

  [data-palmerhq-radio][aria-checked="true"] {
    color: ${({ theme }) => theme.colors.suite[500]};
  }

  [data-palmerhq-radio][aria-checked="false"] {
    color: ${({ theme }) => theme.colors.gray[700]};
  }

  [data-palmerhq-radio] + [data-palmerhq-radio] {
    margin-left: 16px;
  }

  [data-palmerhq-radio]::before,
  [data-palmerhq-radio]::after {
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translate(0%, -50%);
    content: "";
  }

  [data-palmerhq-radio]::before {
    width: 20px;
    height: 20px;
    border: 2px solid ${({ theme }) => theme.colors.gray[600]};
    border-radius: 100%;
  }

  [data-palmerhq-radio][aria-checked="true"]::before {
    border-color: ${({ theme }) => theme.colors.suite[500]};
  }

  [data-palmerhq-radio][aria-checked="true"]::after {
    display: block;
    border: 6px solid ${({ theme }) => theme.colors.suite[500]};
    border-radius: 100%;
    transform: translate(0%, -50%);
    left: 6px;
  }

  [data-palmerhq-radio]:hover::before {
    border-color: ${({ theme }) => theme.colors.suite[500]};
  }

  [data-palmerhq-radio][data-palmerhq-radio-focus="true"]::before {
    box-shadow: 0 0 5px 1px #9f39f8;
  }

  [data-palmerhq-radio]:hover {
    /* maybe a lighter shade of suite purple would look good here */
  }
`;

export const PlanCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.gray[500]};
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: ${({ theme }) => theme.shadows.overlay};
  padding: 26px 30px 33px;

  @media (max-width: 612px) {
    width: 100%;
  }
`;

export const BundleTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.suite[900]};
  margin-bottom: 24px;
`;

export const PlanProductsLayout = styled.div`
  display: flex;
  margin: 0 -12px;

  > * {
    padding: 0 12px;
  }

  @media (max-width: 500px) {
    flex-wrap: wrap;
    justify-content: center;
    width: 252px;
    margin: 0 -12px;

    > *:first-of-type {
      width: 100%;
      margin-bottom: 16px;
    }

    > * {
      padding: 0 12px;
    }
  }
`;

export const Savings = styled.span`
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.accent.purple};
`;

export const PlanPriceLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px auto 0;
`;

export const PlanTerms = styled.span`
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.gray[700]};

  span {
    color: ${({ theme }) => theme.colors.suite[500]};
  }
`;

export const TrialInfo = styled.div`
  width: 100%;
  max-width: 430px;
  margin-top: 24px;
  align-self: flex-start;

  h5 {
    box-sizing: border-box;
    color: #131943;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    margin: 0 0 6px;
    padding: 0;
  }

  p {
    box-sizing: border-box;
    font-family: Circular;
    font-size: 13px;
    font-weight: 300;
    line-height: 22px;
    margin: 0 0 6px;

    strong {
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray[700]};
    }
  }
`;
